export enum DisplayLocation {
    LOGIN = "LOGIN",
    DASHBOARD = "DASHBOARD",
    DATENTAUSCH = "DATENTAUSCH"
}
